module.exports = __webpack_public_path__ + "static/p09_pajaroL-244df7d16532f73a48c65e298360ad79.png";